module.exports = __webpack_public_path__ + "static/images/cover_B3.ac4441e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_B3.png
// module id = LDT/
// module chunks = 8